<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <VueFaqAccordion :items="questions"
      />
    </v-layout>
  </v-container>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'

export default {
  components: {
    VueFaqAccordion
  },
  data () {
    return {
      questions: [
        {
          title: 'Where is your water meter?',
          value: 'Your meter is located near the entrance/front gate to your property. Your water meter reading is recorded on the last of every month and that number can be found on every Invoice. Feel free to check your meter and keep track of your own water usage. Please keep your meter clear of dirt and debris and do not move the markers, these have been placed by the water company.',
          category: 'Questions'
        },
        {
          title: 'What to do if you experience low water pressure or have no water at all?',
          value:
            '<b>Is your water bill up to date?</b> If you are not current on your account you may have been red tagged and your water was shut off and locked. You can contact the water company for the current total owed on your account. You will need to send payment immediately. Payments made on Paypal are recorded within 24 hours.  Payments sent through the mail must be received before the 14th of the month. Your water will remain off until the payment has been received. Paypal link is found on the payment page).' +
            '<br><br>' +
            '<b>Regular maintenance shut off.</b> If you have no water Aqua J Mutual may be working on our water system and your water should return within the hour. Aqua J Mutual works hard testing our water supply monthly and keeping all of our equipment and pipework updated and in good condition. This can sometimes result in the water being shut off for short periods of time.' +
            '<br><br>' +
            '<b>Leaks in your pipes.</b> If you experience low water pressure you may have water running somewhere or a leak in your pipeline. Please check your pipes and property for puddles or wet spots in the ground. If you do find that you have a leak in your system you will need to contact a plumber to fix this problem. You can find your own or use one of these plumbers that Aqua J Mutual has previously worked with. ',
          category: 'Questions'
        },
        {
          title: 'Winter Weather Advisory',
          value: 'During the winter months, October-February, please be aware that the temperature can drop below 32⁰F causing the water in your pipes to freeze. The water should unfreeze during the day however if you would like to help speed the process along you can follow the steps found in this <a href="https://www.wikihow.com/Unfreeze-Water-Pipes">WikiHow</a>.',
          category: 'Weather Advisory'
        }
      ]
    }
  },
  methods: {
  }
}
</script>
